export const MAINTAINER_NAME = 'Aadarsh';
export const MAINTAINER_URL = 'https://aadarsh.online';

export const EXAMPLE_URLS = [
  'https://example.com',
  'https://www.iana.org/help/example-domains',
] as const;
